import { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import FacebookIcon from '../submenu/FacebookIcon';
import InstagramIcon from '../submenu/InstagramIcon';
import LinkedInIcon from '../submenu/LinkedInIcon';
import LocationIcon from '../submenu/LocationIcon';
import PhoneIcon from '../submenu/PhoneIcon';
import TwitterIcon from '../submenu/TwitterIcon';
import YouTubeIcon from '../submenu/YouTubeIcon';
import TandCsIcon from './T&CsIcon';
import TipsIcon from './TipsIcon';
import MobileMyInfoIcon from '../../MobileMyInfoIcon';
import MobileSettingsIcon from '../../MobileSettingsIcon';
import MobileItemsAndPostsIcon from '../../MobileItemsAndPostsIcon';
import PrivacyPolicy from '../../pages/privacypolicy/PrivacyPolicy';
import PrivacyPolicyIcon from './PrivacyPolicyIcon';
import GuestSignInLogo from '../GuestSignInLogo';

export default function HamSubMenuPublic({ hamSubMenuOpen, closeMenu }) {
  const currentYear = new Date().getFullYear();

  const [height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      const viewportHeight = window.innerHeight;
      const divHeight = viewportHeight;
      setHeight(divHeight);
    }, 10);
  }, []);

  return (
    <div className={hamSubMenuOpen}>
      <div className='ham-sub-menu-scrollable' style={{ height }}>
        <div className='sub-menu ham-profile-sub-menu-public'>
          <div className='ham-profile-pic-name-wrap-public'>
            <div className='pic-wrap pic-wrap-placeholder'>
              <GuestSignInLogo fillColor={'#2572a2'} />
            </div>

            <div className='guest-icon-wrapper'>
              <GuestSignInLogo fillColor={'var(--blue-text-bold)'} />
            </div>

            <div className='sub-menu-content'>
              <h6 className='ham-user-name'>Guest User</h6>
            </div>
          </div>
        </div>

        <div className='sub-menu ham-about-sub-menu'>
          <div className='ham-profile-menu-items-wrap'>
            <NavLink
              to='/swapandtop/tou'
              className='ham-about-text-wrap'
              onClick={closeMenu}>
              <TandCsIcon svgClass={'ham-sub-menu-icon'} />
              View terms of use
            </NavLink>
            <NavLink
              to='/swapandtop/privacypolicy'
              className='ham-about-text-wrap'
              onClick={closeMenu}>
              <PrivacyPolicyIcon svgClass={'ham-sub-menu-icon'} />
              View privacy policy
            </NavLink>
            <NavLink
              to='/swapandtop/tipsandrecomandations'
              className='ham-about-text-wrap'
              onClick={closeMenu}>
              <TipsIcon svgClass={'ham-sub-menu-icon'} />
              View tips & recomendations
            </NavLink>
          </div>
        </div>

        <div className='sub-menu ham-contact-us-submenu'>
          <div className='ham-contact-details-wrap'>
            <div className='ham-contact-details'>
              <PhoneIcon svgClass={'ham-sub-menu-icon'} />
              <div>
                <p>+263774 689 010</p>
                <p>+263784 224 614</p>
                <p>+263719 217 717</p>
              </div>
            </div>
            <div className='ham-contact-details'>
              <LocationIcon svgClass={'ham-sub-menu-icon'} />
              <div>
                <p>4442 Ceres Ave</p>
                <p>Waterfalls</p>
                <p>Harare</p>
              </div>
            </div>
          </div>
        </div>
        <div className='sub-menu ham-socials-sub-menu'>
          <div className='ham-feedback-sub-menu'>
            <p>Your feedback is very iportant to us.</p>
            <p>Please e-mail us at</p>
            <a className='selectable-text'>feedback@swapandtop.co.zw</a>
          </div>
          <div className='socials-sub-menu-icons-wrap'>
            <p>Check us out on social</p>
            <div className='ham-socials-icons-wrap'>
              <a href='https://www.facebook.com' target='_blank'>
                <FacebookIcon socialIconClass={'ham-social-icon'} />
              </a>
              <a href='https://www.twitter.com' target='_blank'>
                <TwitterIcon socialIconClass={'ham-social-icon'} />
              </a>
              <a href='https://www.youtube.com' target='_blank'>
                <YouTubeIcon socialIconClass={'ham-social-icon'} />
              </a>
              <a href='https://www.instagram.com' target='_blank'>
                <InstagramIcon socialIconClass={'ham-social-icon'} />
              </a>
              <a href='https://www.linkedin.com' target='_blank'>
                <LinkedInIcon socialIconClass={'ham-social-icon'} />
              </a>
            </div>
          </div>
          <div className='ham-sub-menu-company-name'>
            <a className='selectable-text'>
              © {currentYear} | Greta Works Inc.
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
